import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LangProvider } from "../contexts/LangContext";
import { EmailVerifiedPage } from "../pages/EmailVerifiedPage";

export const Route = createFileRoute("/email-verified")({
  head: () => ({
    meta: [{ title: "Email tasdiqlandi — Lotin.uz" }],
    htmlProps: { lang: "uz-Latn" },
  }),
  component: EmailVerified,
});

function EmailVerified() {
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = "uz-Latn";
    if (i18n?.changeLanguage) i18n.changeLanguage("default");
  }, [i18n]);
  return (
    <LangProvider lang={"uz-Latn"}>
      <EmailVerifiedPage />
    </LangProvider>
  );
}
